// extracted by mini-css-extract-plugin
export default {"aboutTitle":"About_aboutTitle__v4gvv","aboutContainer":"About_aboutContainer__5onN1","aboutContent":"About_aboutContent__7uII1","navbar--hidden":"About_navbar--hidden__D58RX"};